/* eslint-disable ember/no-classic-components, ember/require-tagless-components */
import { tracked } from '@glimmer/tracking';
import Component from '@ember/component';
import { action } from '@ember/object';
import { service } from '@ember/service';

export default class HeroNotificationsReadAll extends Component {
  // Component versioning
  @tracked visualStyle = 'v1';

  @service
  notifications;

  @service
  toaster;

  // Whether we're currently marking notifications as read.
  @tracked
  markAllReadInProgress = false;

  @action
  markAllRead() {
    this.markAllReadInProgress = true;
    this.notifications
      .markAllRead()
      .then(() => {
        this.toaster.success(`All notifications marked read.`);
      })
      .catch(() => {
        this.toaster.error(
          "Notifications couldn't be marked as read. Please try again later.",
        );
      })
      .finally(() => {
        this.notifications.refresh();
        this.markAllReadInProgress = false;
      });
  }
}
